import { FeatureFlagCondition } from '@jenmusic/feature-flag';

export const FEATURE_FLAG_CONFIG = {
  showNewGenerator: ['all'],
  showAdvancedDetails: ['local', 'dev', 'staging', 'industry'],
  showStyleFilters: ['local', 'dev', 'staging', 'industry', 'prod'],
  showNewNavigationBar: ['local', 'dev', 'staging', 'prod'],
  showShopFilters: ['local', 'dev', 'staging', 'prod'],
  showSoulMate: [],
  showBarsBeats: ['local', 'dev'],
  showSuperVoice: ['local', 'dev'],
  showModelVersionSelector: [{ envs: ['dev', 'staging', 'prod'], emails: ['@jenmusic.ai'] }],
  showJen2: [{ envs: ['dev', 'staging', 'prod'], emails: ['@jenmusic.ai'] }],
} as const satisfies Record<string, FeatureFlagCondition[]>;

export const PLAN_MAP_PERMISSION = JSON.parse(process.env.SUBSCRIPTION_GATING || '');
